import React from 'react';
import { withRouter } from 'react-router-dom';

export function GoBackButton({ history }) {
  return (
    <button
      className="button--link"
      onClick={history.goBack}
      style={{ marginRight: '1rem' }}
      type="button"
    >
      <i className="fa fa-arrow-left back-button" />
    </button>
  );
}

export default withRouter(GoBackButton);